import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login'
import Data from '../components/Data'
import useraccount from '../components/table/account/useraccount'
import welcome from '../components/table/welcome'
import bucketproductsnbind from '../components/table/bucket/bucketproductsnbind'
import adduseraccount from '../components/table/account/adduseraccount'
import addbucketproductsn from '../components/table/bucket/addbucketproductsn.vue'
import addgunproductsn from '../components/table/gun/addgunproductsn.vue'
import gunproductsnbind from '../components/table/gun/gunproductsnbind'
import addappversion from '../components/table/appversion/addappversion'
import appversion from '../components/table/appversion/appversion'
import gunlogininfo from '../components/table/gun/gunlogininfo'
import bucketlogininfo from '../components/table/bucket/bucketlogininfo'
import Register from '../components/table/register/register'
import success from '../components/table/register/success'
import user from '../components/table/user/user'
import adduser from '../components/table/user/adduser'
import productversion from '../components/table/productversion/productversion'
import addproductversion from '../components/table/productversion/addproductversion'
// import test from '../components/table/test'
Vue.use(Router)

let router = new Router({
  mode: 'hash', // 修改为 hash 模式
  routes: [
    {
      path: '/',
      component: Login
    },
    {
      path: '/register',
      component: Register
    },
    {
      path: '/success',
      component: success
    },
    {
      path: '/data',
      component: Data,
      children: [
        {
          path: 'useraccount',
          component: useraccount
        },
        {
          path: 'welcome',
          component: welcome
        },
        {
          path: 'bucketproductsnbind',
          component: bucketproductsnbind
        },
        {
          path: 'gunproductsnbind',
          component: gunproductsnbind
        },
        {
          path: 'addaccount',
          component: adduseraccount
        },
        {
          path: 'addgunproductsn',
          component: addgunproductsn
        },
        {
          path: 'addbucketproductsn',
          component: addbucketproductsn
        },
        {
          path: 'appversion',
          component: appversion
        },
        {
          path: 'addappversion',
          component: addappversion
        },
        {
          path: 'productversion',
          component: productversion
        },
        {
          path: 'addproductversion',
          component: addproductversion
        },
        {
          path: 'gunlogininfo',
          component: gunlogininfo
        },
        {
          path: 'bucketlogininfo',
          component: bucketlogininfo
        },
        {
          path: 'adduser',
          component: adduser
        },
        {
          path: 'user',
          component: user
        }

        // ,
        // {
        //   path: 'test',
        //   component: test
        // }
      ]
    }
  ]
})

// const router = new Router({
//   mode: 'history', // 使用 history 模式，URL 更美观 (部署时需要后端配置支持)
//   base: '/',
//   routes
// })

// router.beforeEach((to, from, next) => {
//   const role = localStorage.getItem('username')
//   if (role) {
//     next()
//   } else {
//     if (to.path === '/login') {
//       next()
//     } else {
//       next('/login')
//     }
//   }
// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js